import { cva } from '@/styled-system/css';

export const textAreaRecipe = cva({
  base: {
    paddingBlock: 'Textarea.padding.vert',
    borderRadius: 'Textarea',
    /* https://stackoverflow.com/questions/7144843/extra-space-under-textarea-differs-along-browsers */
    verticalAlign: 'top',
  },
  variants: {
    readOnly: {
      true: { paddingInline: 'Textarea.padding.horz-readOnly' },
      false: { paddingInline: 'Textarea.padding.horz' },
    },
  },
});
